<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rRWEDJ/images/cover.jpg?1684988648293" alt="This image is the cover for the book Sunday Comes Every Week"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sunday Comes Every Week
      </h1>
      <p class="bookDescription body article font2">
        <p><i>Seasoned advice for pastors facing the weekly challenge of preparing sermons</i></p><p>For pastors, a new sermon comes every week. Conventional wisdom says that pastors need to sequester themselves to prepare their weekly sermon without distraction. But veteran preacher Frank Honeycutt suggests just the opposite: prepare your sermons as part of a daily, lived experience in the community.</p><p>Using the days of the week as a framework, Honeycutt describes practical and essential tasks leading up to the writing and delivery of the Sunday sermon—habits that will provide lasting spiritual nourishment for pastors who plan for a long career in parish ministry. With humor and candid acknowledgment of his own mistakes and doubts, Honeycutt reflects on the joys and hazards of ministry and explains how a faithful process of preaching shapes pastors for a lifetime of healthy ministry.</p>Monday: ListeningTuesday: HearingWednesday: ExegetingThursday: NamingReflecting: A Pastor Looks BackFriday: WritingSaturday: RehearsingSunday: Offering
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Frank G. Honeycutt, Thomas G. Long
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      William B. Eerdmans Publishing Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?d5e870a8